import isUndefined from "lodash/isUndefined";
import isNull from "lodash/isNull";

import {
  getUsers as getUsersRepository,
  getUserById as getUserByIdRepository,
  removeUser as removeUserRepository,
  createUser as createUserRepository,
  updateUser as updateUserRepository,
} from "../repositories/userRepository";

const userService = {
  getUsers: async ({ currentPage, pageSize, search }) => {
    const pageNumber =
      isUndefined(currentPage) || isNull(currentPage) ? 1 : currentPage;
    const itemsPerPage =
      isUndefined(pageSize) || isNull(pageSize) ? 20 : pageSize;

    const params = {
      "current-page": Number(pageNumber),
      "page-size": itemsPerPage,
    };
    if (search?.trim()) params.search = search.trim();
    return await getUsersRepository(params);
  },

  getUserById: async (id) => await getUserByIdRepository(id),

  removeUser: async (userId) => await removeUserRepository(userId),

  createUser: async (body) => await createUserRepository(body),

  updateUser: async (body) => await updateUserRepository(body),
};

export default userService;
